import type { UNITS } from '@/app/common/measures/types.ts';
import { DISTANCE_UNITS, WEIGHT_UNITS } from '@/app/common/measures/types.ts';

const toFixedIfNecessary = (value: number, decimals: number) => +value.toFixed(decimals);
const fixedIfNecessary = (value: number) => toFixedIfNecessary(value, 2);
const round = (v: number) => Math.round(v);

export const getRoundingFunction = (unit: UNITS): ((n: number) => number) | undefined => {
  switch (unit) {
    // DISTANCE UNITS
    case DISTANCE_UNITS.KM:
    case DISTANCE_UNITS.MI:
      return fixedIfNecessary;
    case DISTANCE_UNITS.M:
    case DISTANCE_UNITS.FT:
      return round;

    // WEIGHT UNITS
    case WEIGHT_UNITS.KG:
    case WEIGHT_UNITS.LBS:
    case WEIGHT_UNITS.OZ:
      return fixedIfNecessary;
    case WEIGHT_UNITS.G:
      return round;

    default:
      return undefined;
  }
};

export const applyRounding = (value: number, roundFunction?: (n: number) => number): number => {
  if (roundFunction) {
    return roundFunction(value);
  }
  return value;
};
